module.exports = __webpack_public_path__ + "img/skeleton.a4c6e423.svg";